import React from 'react';
import Paginate from 'react-paginate';
import clsx from 'clsx';
import { usePagination, Props } from './usePagination';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAngleLeft,
  faAngleDoubleLeft,
  faAngleRight,
  faAngleDoubleRight,
  faEllipsis } from
'@fortawesome/free-solid-svg-icons';
import styles from './Pagination.module.css';

export const Pagination: React.FC<Props> = (props) => {
  const {
    currentPage,
    pageTotal,
    onChangePage,
    onClickFirst,
    onClickLast,
    onClick,
    isFirst,
    isLast
  } = usePagination(props);

  return (
    <div className={styles.root}>
      <div className={styles.firstItem}>
        <a
          href="#"
          className={clsx(styles.pageLink, isFirst && styles.disabledLink)}
          onClick={onClickFirst}>

          <FontAwesomeIcon icon={faAngleDoubleLeft} />
        </a>
      </div>

      <div className={styles.lastItem}>
        <a
          href="#"
          className={clsx(styles.pageLink, isLast && styles.disabledLink)}
          onClick={onClickLast}>

          <FontAwesomeIcon icon={faAngleDoubleRight} />
        </a>
      </div>
    </div>);

};